import { render, staticRenderFns } from "./VideoPageMobile.vue?vue&type=template&id=7f07a4fc&scoped=true"
import script from "./VideoPageMobile.vue?vue&type=script&lang=js"
export * from "./VideoPageMobile.vue?vue&type=script&lang=js"
import style0 from "./VideoPageMobile.vue?vue&type=style&index=0&id=7f07a4fc&prod&scoped=true&lang=scss"
import style1 from "./VideoPageMobile.vue?vue&type=style&index=1&id=7f07a4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07a4fc",
  null
  
)

export default component.exports